export default "__VITE_ASSET__CSFNffQY__"